window.ACNE_TRIGGERS = {
  "ingredients": [
    {
      "name": "isopropyl myristate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isopropyl palmitate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isopropyl isostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isopropyl lanolate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "myristyl myristate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "myristyl lactate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "butyl stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "butyl oleate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "butyl palmitate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "butyl myristate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "butyl isostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "decyl oleate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isodecyl oleate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isocetyl stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isocetyl isostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "octyl palmitate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "ethylhexyl palmitate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cetyl palmitate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cetyl stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cetearyl isononanoate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cetearyl ethylhexanoate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cetearyl isostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isostearyl isostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isostearyl palmitate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isostearyl neopentanoate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "octyldodecyl myristate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "octyldodecyl oleate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "octyldodecyl stearoyl stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "octyldodecyl stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "2-ethylhexyl palmitate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "2-ethylhexyl stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "2-ethylhexyl myristate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "2-ethylhexyl oleate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "2-ethylhexyl laurate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "ethylhexyl stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "ethylhexyl oleate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "ethylhexyl isostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "propylene glycol monostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "propylene glycol monopalmitate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "propylene glycol dicaprylate/dicaprate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "glyceryl stearate se",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "glyceryl stearate citrate high % rich formulas",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "peg-100 stearate rich leave-ons",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "sorbitan oleate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "sorbitan isostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "sorbitan sesquioleate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "sorbitan stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "polyglyceryl-3 diisostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "polyglyceryl-4 diisostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "polyglyceryl-2 diisostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "diisostearyl malate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "diisopropyl adipate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "diethylhexyl succinate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "dioctyl succinate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "diethylhexyl syringylidenemalonate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "diethylhexyl carbonate rich blends",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "pentaerythrityl tetraisostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "pentaerythrityl tetraethylhexanoate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "trimethylolpropane triisostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "trimethylolpropane triethylhexanoate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "neopentyl glycol diethylhexanoate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "neopentyl glycol diheptanoate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "c12-15 alkyl benzoate some acne-prone users",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "c12-15 alkyl lactate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "c12-15 alkyl ethylhexanoate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isopropyl titanium triisostearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isopropyl alcohol irritation-triggered acne",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "isopropanol irritation-triggered acne",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "lanolin",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "lanolin oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "lanolin wax",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "lanolin alcohol",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "acetylated lanolin",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "acetylated lanolin alcohol",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "peg-16 lanolin",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "peg-75 lanolin",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "ethoxylated lanolin",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "hydrogenated lanolin",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "hydroxylated lanolin",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "lanolin acid",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "algae extract",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "seaweed extract",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "kelp extract",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "laminaria digitata extract",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "laminaria saccharina extract",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "chondrus crispus carrageenan",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "carrageenan",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "irish moss extract",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "spirulina extract",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "chlorella extract",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "algin",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "sodium alginate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "coconut oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cocos nucifera coconut oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cocoa butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "theobroma cacao cocoa seed butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "wheat germ oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "triticum vulgare wheat germ oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "avocado oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "persea gratissima avocado oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "soybean oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "glycine soja soybean oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "flaxseed oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "linum usitatissimum linseed seed oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "palm oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "elaeis guineensis palm oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "olive oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "olea europaea olive fruit oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "macadamia oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "macadamia integrifolia seed oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "peanut oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "arachis hypogaea peanut oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cottonseed oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "gossypium herbaceum cotton seed oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "corn oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "zea mays corn germ oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "sesame oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "sesamum indicum sesame seed oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "almond oil sweet",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "prunus amygdalus dulcis sweet almond oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "apricot kernel oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "prunus armeniaca apricot kernel oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "hazelnut oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "corylus avellana hazel seed oil",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "shea butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "butyrospermum parkii shea butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "mango seed butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "mangifera indica mango seed butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "kokum butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "garcinia indica seed butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cupua\u00e7u butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "theobroma grandiflorum seed butter",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "beeswax",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "cera alba",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "candelilla wax",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "euphorbia cerifera candelilla wax",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "carnauba wax",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "copernicia cerifera carnauba wax",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "ozokerite",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "paraffin",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "microcrystalline wax",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "synthetic wax",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "petrolatum very occlusive in some acne-prone routines",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "mineral oil heavy occlusion in some routines",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "paraffinum liquidum",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "laureth-4",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "oleth-3",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "oleth-10 rich leave-ons",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "laureth-23 leave-ons",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "peg-2 stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "peg-8 stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "peg-40 stearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "peg-150 distearate",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "polysorbate 60",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "polysorbate 80",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "polysorbate 20 some",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "lauric acid",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "myristic acid",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "oleic acid",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "palmitic acid",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "stearic acid",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "dandc red no 3",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "dandc red no 4",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "dandc red no 6",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "dandc red no 7",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    },
    {
      "name": "dandc red no 17",
      "tier": "RED",
      "reason": "Listed as RED acne trigger"
    }
  ],
  "aliases": {
    "ipm": "ipm",
    "isopropylmyristate": "isopropylmyristate",
    "isopropyl palmitate": "isopropyl palmitate",
    "2 ethylhexyl palmitate": "2 ethylhexyl palmitate",
    "octyl palmitate": "octyl palmitate",
    "ethylhexyl hexadecanoate": "ethylhexyl hexadecanoate",
    "seaweed": "seaweed",
    "algae": "algae",
    "kelp": "kelp",
    "irish moss": "irish moss",
    "chondrus crispus extract": "chondrus crispus extract",
    "cocos nucifera oil": "cocos nucifera oil",
    "coconut": "coconut",
    "theobroma cacao butter": "theobroma cacao butter",
    "triticum vulgare germ oil": "triticum vulgare germ oil",
    "paraffin oil": "paraffin oil",
    "liquid paraffin": "liquid paraffin",
    "mineral oil": "mineral oil",
    "petroleum jelly": "petroleum jelly",
    "cera alba": "cera alba",
    "bees wax": "bees wax",
    "macadamia integrifolia seed oil": "macadamia integrifolia seed oil",
    "olea europaea fruit oil": "olea europaea fruit oil",
    "glycine soja oil": "glycine soja oil",
    "butyrospermum parkii butter": "butyrospermum parkii butter",
    "isopropyl myristate": "isopropyl myristate",
    "ethylhexyl palmitate": "ethylhexyl palmitate",
    "ethylhexylpalmitate": "ethylhexylpalmitate",
    "laureth 4": "laureth 4",
    "laureth-4": "laureth-4",
    "carrageenan": "carrageenan",
    "algae extract": "algae extract",
    "algaeextract": "algaeextract",
    "coconut oil": "coconut oil",
    "coconutoil": "coconutoil",
    "shea butter": "shea butter",
    "sheabutter": "sheabutter",
    "lanolin": "lanolin"
  }
};